/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable one-var */
// vue
import Vue from 'vue'
// vuex
import Vuex from 'vuex'
// vuesex
import Vuesax from 'vuesax'
// vuerout
import Router from 'vue-router'
// store
import store from '@/store'
// vuesex
import 'vuesax/dist/vuesax.css'
// uuid
import UUID from 'vue-uuid'
// date picker
import DatePicker from '../lib/v-calendar/components/DatePicker.vue'
// Material icons used by this framework are currently not included
import 'material-icons/iconfont/material-icons.css'
// local storage
import LocalStorage from 'store'
// Cleave.js
import Cleave from 'vue-cleave-component'
// google analytics
import VueAnalytics from 'vue-analytics'
// barcode scanner
import VueBarcodeScanner from 'vue-barcode-scanner'
// Reactive Vue.js wrapper for Google Charts lib
import VueGoogleCharts from 'vue-google-charts'
// refers to components/ECharts.vue in webpack
import ECharts from 'vue-echarts'
// Simple, lightweight model-based validation for Vue.js 2.0
import Vuelidate from 'vuelidate'
// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/legendScroll'
// Payment UI Form
import VueCardFormat from 'vue-credit-card-validation'

import VueBootstrapAutocomplete from '../lib/autocomplete/VueBootstrapAutocomplete'
import RecycleScroller from '../lib/vue-virtual-scroller/components/RecycleScroller.vue'

import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'

// config project
import project from '@/project'

/**
 ** import components
 **/
// base
import BaseBody from '@/components/base/BaseBody'
import BaseTopBar from '@/components/base/BaseTopBar'
import BaseTopBarContent from '@/components/base/BaseTopBarContent'
import BaseContent from '@/components/base/BaseContent'
import BaseTable from '@/components/base/BaseTable'
import BaseTableCollapse from '@/components/base/BaseTableCollapse'
import BaseInput from '@/components/base/BaseInput'
import BaseInputDatePicker from '@/components/base/BaseInputDatePicker'
import BaseDateRange from '@/components/base/BaseDateRange'
import BaseInputNumber from '@/components/base/BaseInputNumber'
import BaseInputTag from '@/components/base/BaseInputTag'
import BaseInputVariable from '@/components/base/BaseInputVariable'
import BaseInputSelector from '@/components/base/BaseInputSelector'
import BaseTextArea from '@/components/base/BaseTextArea'
import BaseRadioRich from '@/components/base/BaseRadioRich'
import BaseCheckbox from '@/components/base/BaseCheckbox'
import BaseSortLabel from '@/components/base/BaseSortLabel'
import BaseDropdown from '@/components/base/BaseDropdown'
import BaseSwitch from '@/components/base/BaseSwitch'
import BaseDropdownFilterDateRange from '@/components/base/BaseDropdownFilterDateRange'
import BaseDropdownFilterDownload from '@/components/base/BaseDropdownFilterDownload'
import BaseAction from '@/components/base/BaseAction'
import BaseActionDropdown from '@/components/base/BaseActionDropdown'
import BaseActionUpdateStatus from '@/components/base/BaseActionUpdateStatus'
import BaseFilterDataType from '@/components/base/BaseFilterDataType'
import BaseFilterDocProcessStatus from '@/components/base/BaseFilterDocProcessStatus'
import BaseEChart from '@/components/base/BaseEChart'
import BaseAssignItems from '@/components/base/BaseAssignItems'
import BaseAssignSkus from '@/components/base/BaseAssignSkus'
import BaseConfirmDeleteModal from '@/components/base/BaseConfirmDeleteModal'
import BaseConfirmDiscardModal from '@/components/base/BaseConfirmDiscardModal'
import BaseAlertModal from '@/components/base/BaseAlertModal'
import BaseNotFoundData from '@/components/base/BaseNotFoundData'
import BaseFormAction from '@/components/base/BaseFormAction'
import BaseButton from '@/components/base/BaseButton'
import BaseButtonGroup from '@/components/base/BaseButtonGroup'
import BasePayrollCondition from '@/components/base/BasePayrollCondition'
import BasePaySlipEmployee from '@/components/base/BasePaySlipEmployee'
import BasePaySlipEmployeeHead from '@/components/base/BasePaySlipEmployeeHead'
import BasePaySlipEmployeeItem from '@/components/base/BasePaySlipEmployeeItem'
import BaseDocumentProcessStatus from '@/components/base/BaseDocumentProcessStatus'
import Section from '@/components/base/Section'
import FormRow from '@/components/base/FormRow'
import Col from '@/components/base/Col'
import Label from '@/components/base/Label'
import BaseSelectLotNumber from '@/components/base/BaseSelectLotNumber'
import BaseSelectLotNumberModal from '@/components/base/BaseSelectLotNumberModal'
import BaseSelectSerialNumber from '@/components/base/BaseSelectSerialNumber'
import BaseSelectSerialNumberModal from '@/components/base/BaseSelectSerialNumberModal'
import BaseGRPutAwayLot from '@/components/base/BaseGRPutAwayLot'
import BaseGRPutAwaySerial from '@/components/base/BaseGRPutAwaySerial'
import BaseGTPutAwayLot from '@/components/base/BaseGTPutAwayLot'
import BaseGTPutAwaySerial from '@/components/base/BaseGTPutAwaySerial'
import BaseBinLocationModal from '@/components/base/BaseBinLocationModal'
import BaseTableSkuLevel from '@/components/base/BaseTableSkuLevel'
import BaseVsInputNumber from '@/components/base/BaseVsInputNumber'
import BaseRolePermission from '@/components/base/BaseRolePermission'
import BaseSelectRolePermission from '@/components/base/BaseSelectRolePermission'
import BaseTableUsegeApp from '@/components/base/BaseTableUsegeApp'
import BaseTableUsegeBranch from '@/components/base/BaseTableUsegeBranch'
import BaseTableUsegeWarehouse from '@/components/base/BaseTableUsegeWarehouse'
import BaseTableUsegeUser from '@/components/base/BaseTableUsegeUser'
import BaseTableUsegeFile from '@/components/base/BaseTableUsegeFile'
import BaseTableUsegeMessageLine from '@/components/base/BaseTableUsegeMessageLine'
import BaseTableUsegeEmail from '@/components/base/BaseTableUsegeEmail'
import BaseTableUsegeQRCode from '@/components/base/BaseTableUsegeQRCode'
import BaseTableUsegeAppModule from '@/components/base/BaseTableUsegeAppModule'
import BaseLoading from '@/components/base/BaseLoading'
import BaseRadioPaymentMethod from '@/components/base/BaseRadioPaymentMethod'
import BasePayment from '@/components/base/BasePayment'
import BasePaymentForm from '@/components/base/BasePaymentForm'
import BaseCreditCardForm from '@/components/base/BaseCreditCardForm'
import BaseModal from '@/components/base/BaseModal'
import BaseModalOverLimit from '@/components/base/BaseModalOverLimit'
import BaseAppModuleListModule from '@/components/base/BaseAppModuleListModule'
import BaseFormPaymentMethod from '@/components/base/BaseFormPaymentMethod'
import BaseFormBillingPreference from '@/components/base/BaseFormBillingPreference'
import BaseModalCustomMasterData from '@/components/base/BaseModalCustomMasterData'
import BaseModalAckFreeTrialEnded from '@/components/base/BaseModalAckFreeTrialEnded'
import BaseModalPackage from '@/components/base/BaseModalPackage'

// combine
import ReportSaleTable from '@/components/combine/ReportSaleTable'
import ReportSaleChart from '@/components/combine/ReportSaleChart'
import ReportCashierTable from '@/components/combine/ReportCashierTable'
import ReportCashierChart from '@/components/combine/ReportCashierChart'
import ReportInventoryTable from '@/components/combine/ReportInventoryTable'
import ReportInventoryChart from '@/components/combine/ReportInventoryChart'
import ReportPosPaymentMethodChart from '@/components/combine/ReportPosPaymentMethodChart'
import ReportPosDiningOptionChart from '@/components/combine/ReportPosDiningOptionChart'
import ReportPosSkuChart from '@/components/combine/ReportPosSkuChart'
import ReportPosCategoryChart from '@/components/combine/ReportPosCategoryChart'
import HrmEmployeeForm from '@/components/combine/HrmEmployeeForm'
import HrmDepartmentForm from '@/components/combine/HrmDepartmentForm'
import HrmPositionForm from '@/components/combine/HrmPositionForm'
import PayrollPaySlipForm from '@/components/combine/PayrollPaySlipForm'
import PayrollEmployeeGroupForm from '@/components/combine/PayrollEmployeeGroupForm'
import PayrollConditionForm from '@/components/combine/PayrollConditionForm'
import WmsWarehouseForm from '@/components/combine/WmsWarehouseForm'
import ImsLotNumberForm from '@/components/combine/ImsLotNumberForm'
import ImsSerialNumberForm from '@/components/combine/ImsSerialNumberForm'
import RolePermissionForm from '@/components/combine/RolePermissionForm'
import UserPermissionForm from '@/components/combine/UserPermissionForm'
import BillingInvoiceSummary from '@/components/combine/BillingInvoiceSummary'
import BillingInvoiceUsage from '@/components/combine/BillingInvoiceUsage'
import BillingPaymentMethodForm from '@/components/combine/BillingPaymentMethodForm'
import ServiceUsedSummary from '@/components/combine/ServiceUsedSummary'
import CustomMasterDataForm from '@/components/combine/CustomMasterDataForm'

// account folder
import SignIn from '@/components/account/SignIn'
import SignUp from '@/components/account/SignUp'
import ChooseShop from '@/components/account/ChooseShop'
import CreateShop from '@/components/account/CreateShop'
import CheckVerifyEmail from '@/components/account/CheckVerifyEmail'
import ResetPassword from '@/components/account/ResetPassword'

// Payment
import PaymentInvoice from '@/components/payment/Invoice'
import PaymentCallbackAuth from '@/components/payment/CallbackAuth'

// Payment Package
import PaymentPackageInvoice from '@/components/paymentpackage/Invoice'
import PaymentPackageCallbackAuth from '@/components/paymentpackage/CallbackAuth'

// Callback
import LoginWithLine from '@/components/callback/LoginWithLine'

// home folder
import Home from '@/components/home/Home'

// POS Point of Sale
import PosDashboard from '@/components/apps/pos/sale/All.vue'
import PosDashboardSession from '@/components/apps/pos/sale/Session'
import PosTransactionAll from '@/components/apps/pos/transaction/All.vue'
import PosBranchAll from '@/components/apps/pos/branch/All.vue'
import PosBranchNew from '@/components/apps/pos/branch/New.vue'
import PosBranchEdit from '@/components/apps/pos/branch/Edit.vue'
import PosTransactionDetail from '@/components/apps/pos/transaction/Detail.vue'
import PosConfigurationSetting from '@/components/apps/pos/configuration/Setting.vue'
import PosConfigurationNotification from '@/components/apps/pos/configuration/Notification.vue'
import PosMenuOnlineQRCode from '@/components/apps/pos/menuonline/QRCode.vue'

// items folder
import ProductAll from '@/components/apps/items/product/All'
import ProductNew from '@/components/apps/items/product/New'
import ProductEdit from '@/components/apps/items/product/Edit'
import CategoryAll from '@/components/apps/items/category/All'
import CategoryNew from '@/components/apps/items/category/New'
import CategoryEdit from '@/components/apps/items/category/Edit'
import ModifierAll from '@/components/apps/items/modifier/All'
import ModifierNew from '@/components/apps/items/modifier/New'
import ModifierEdit from '@/components/apps/items/modifier/Edit'
import DiscountAll from '@/components/apps/items/discount/All'
import DiscountNew from '@/components/apps/items/discount/New'
import DiscountEdit from '@/components/apps/items/discount/Edit'
import RecipeAll from '@/components/apps/items/recipe/All'
import RecipeNew from '@/components/apps/items/recipe/New'
import RecipeEdit from '@/components/apps/items/recipe/Edit'

// sale folder
import SaleOrderAll from '@/components/apps/sales/so/All'
import SaleOrderNew from '@/components/apps/sales/so/New'
import SaleOrderEdit from '@/components/apps/sales/so/Edit'
import SaleType from '@/components/apps/sales/type/List'

// purchase folder
import PurchaseRequisitionAll from '@/components/apps/purchases/pr/All'
import PurchaseRequisitionNew from '@/components/apps/purchases/pr/New'
import PurchaseRequisitionEdit from '@/components/apps/purchases/pr/Edit'
import PurchaseOrderAll from '@/components/apps/purchases/po/All'
import PurchaseOrderNew from '@/components/apps/purchases/po/New'
import PurchaseOrderEdit from '@/components/apps/purchases/po/Edit'
import PurchaseType from '@/components/apps/purchases/type/List'
import PurchaseConfigurationSetting from '@/components/apps/purchases/configuration/Setting'
import PurchaseConfigurationNotification from '@/components/apps/purchases/configuration/Notification'
import SaleConfigurationSetting from '@/components/apps/sales/configuration/Setting'
import AccountConfigurationSetting from '@/components/apps/accounts/configuration/Setting'

// expense folder
import ExpensesClaimAll from '@/components/apps/expenses/ex/All'
import ExpensesClaimNew from '@/components/apps/expenses/ex/New'
import ExpensesClaimEdit from '@/components/apps/expenses/ex/Edit'
import ExpensesConfigurationSetting from '@/components/apps/expenses/configuration/Setting'
import ExpensesType from '@/components/apps/expenses/type/List'

// accounts
import AccountsOverviewAll from '@/components/apps/accounts/overview/All'
import AccountsInvoiceAll from '@/components/apps/accounts/invoice/All'
import AccountsInvoiceNew from '@/components/apps/accounts/invoice/New'
import AccountsInvoiceEdit from '@/components/apps/accounts/invoice/Edit'
import AccountsReceiptAll from '@/components/apps/accounts/receipt/All'
import AccountsReceiptEdit from '@/components/apps/accounts/receipt/Edit'
import AccountsPaymentEntryAll from '@/components/apps/accounts/paymententry/All'
import AccountsPaymentEntryNew from '@/components/apps/accounts/paymententry/New'
import AccountsPaymentEntryEdit from '@/components/apps/accounts/paymententry/Edit'
import AccountsJournalEntryAll from '@/components/apps/accounts/journalentry/All'
import AccountsJournalEntryNew from '@/components/apps/accounts/journalentry/New'
import AccountsJournalEntryEdit from '@/components/apps/accounts/journalentry/Edit'
import AccountsChartOfAccount from '@/components/apps/accounts/chartofaccount/Index'
import TaxAll from '@/components/apps/accounts/tax/All'
import TaxNew from '@/components/apps/accounts/tax/New'
import TaxEdit from '@/components/apps/accounts/tax/Edit'

// inventory folder
import InventoryTodo from '@/components/apps/inventory/overview/Todo'
import InventorySkuLevel from '@/components/apps/inventory/overview/SkuLevel'
import StockControl from '@/components/apps/inventory/stockcontrol/List'
import StockActivity from '@/components/apps/inventory/activity/List'
import GoodsReceiptAll from '@/components/apps/inventory/goodsreceipt/All'
import GoodsReceiptNew from '@/components/apps/inventory/goodsreceipt/New'
import GoodsReceiptEdit from '@/components/apps/inventory/goodsreceipt/Edit'
import GoodsIssueAll from '@/components/apps/inventory/goodsissue/All'
import GoodsIssueNew from '@/components/apps/inventory/goodsissue/New'
import GoodsIssueEdit from '@/components/apps/inventory/goodsissue/Edit'
import GoodsTransferAll from '@/components/apps/inventory/goodstransfer/All'
import GoodsTransferNew from '@/components/apps/inventory/goodstransfer/New'
import GoodsTransferEdit from '@/components/apps/inventory/goodstransfer/Edit'
import WarehouseList from '@/components/apps/inventory/warehouse/List'
import WarehouseCreate from '@/components/apps/inventory/warehouse/Create'
import WarehouseEdit from '@/components/apps/inventory/warehouse/Edit'
import InventoryConfigurationNotification from '@/components/apps/inventory/configuration/Notification'
import InventoryConfigurationAssignLotSerial from '@/components/apps/inventory/configuration/AssignLotSerial'
import InventoryConfigurationAssignSku from '@/components/apps/inventory/configuration/AssignSku'
import InventoryConfigurationSetting from '@/components/apps/inventory/configuration/Setting'
import InventoryLotList from '@/components/apps/inventory/lotnumber/List'
import InventoryLotCreate from '@/components/apps/inventory/lotnumber/Create'
import InventoryLotEdit from '@/components/apps/inventory/lotnumber/Edit'
import InventorySerialList from '@/components/apps/inventory/serialnumber/List'
import InventorySerialCreate from '@/components/apps/inventory/serialnumber/Create'
import InventorySerialEdit from '@/components/apps/inventory/serialnumber/Edit'

// report folder
import ReportPosSale from '@/components/apps/report/pos/Sale'
import ReportPosCashier from '@/components/apps/report/pos/Cashier'
import ReportPosProduct from '@/components/apps/report/pos/Product'
import ReportPosCategory from '@/components/apps/report/pos/Category'
import ReportPosDiningOption from '@/components/apps/report/pos/DiningOption'
import ReportPosPaymentMethod from '@/components/apps/report/pos/PaymentMethod'
import ReportIncomeStatementAll from '@/components/apps/report/income-statement/All'
import ReportInventoryBalance from '@/components/apps/report/inventory/Balance'
import ReportInventoryValue from '@/components/apps/report/inventory/Value'
import ReportInventoryInOut from '@/components/apps/report/inventory/InOut'
import ReportInventoryBehavior from '@/components/apps/report/inventory/Behavior'
import ReportExpenseDescription from '@/components/apps/report/expense/Description'
import ReportExpenseCategory from '@/components/apps/report/expense/Category'
import ReportExpenseEmployee from '@/components/apps/report/expense/Employee'
import ReportExpenseApprover from '@/components/apps/report/expense/Approver'
import ReportExpenseVendor from '@/components/apps/report/expense/Vendor'
import ReportPurchaseSku from '@/components/apps/report/purchase/Sku'
import ReportPurchaseCategory from '@/components/apps/report/purchase/Category'
import ReportPurchaseEmployee from '@/components/apps/report/purchase/Employee'
import ReportPurchaseApprover from '@/components/apps/report/purchase/Approver'
import ReportPurchaseVendor from '@/components/apps/report/purchase/Vendor'

// contact folder
import ContactListAll from '@/components/apps/contact/list/All'
import ContactVendorAll from '@/components/apps/contact/vendor/All'
import ContactVendorNew from '@/components/apps/contact/vendor/New'
import ContactVendorEdit from '@/components/apps/contact/vendor/Edit'
import ContactCustomerAll from '@/components/apps/contact/customer/All'
import ContactCustomerNew from '@/components/apps/contact/customer/New'
import ContactCustomerEdit from '@/components/apps/contact/customer/Edit'

// human resource management
import EmployeeList from '@/components/apps/hrm/employee/List'
import EmployeeCreate from '@/components/apps/hrm/employee/Create'
import EmployeeEdit from '@/components/apps/hrm/employee/Edit'
import DepartmentList from '@/components/apps/hrm/department/List'
import DepartmentCreate from '@/components/apps/hrm/department/Create'
import DepartmentEdit from '@/components/apps/hrm/department/Edit'
import PositionList from '@/components/apps/hrm/position/List'
import PositionCreate from '@/components/apps/hrm/position/Create'
import PositionEdit from '@/components/apps/hrm/position/Edit'

// payroll
import PaySlipList from '@/components/apps/payroll/payslip/List'
import PaySlipCreate from '@/components/apps/payroll/payslip/Create'
import PaySlipEdit from '@/components/apps/payroll/payslip/Edit'
import EmployeeGroupList from '@/components/apps/payroll/group/List'
import EmployeeGroupCreate from '@/components/apps/payroll/group/Create'
import EmployeeGroupEdit from '@/components/apps/payroll/group/Edit'
import PaySlipConditionList from '@/components/apps/payroll/condition/List'
import PaySlipConditionCreate from '@/components/apps/payroll/condition/Create'
import PaySlipConditionEdit from '@/components/apps/payroll/condition/Edit'
import PayrollConfigurationSetting from '@/components/apps/payroll/configuration/Setting'

// applications folder
import AppsCategoryAll from '@/components/apps/applications/category/All'
import AppsCategoryBoostSales from '@/components/apps/applications/category/BoostSales'
import AppsCategoryOparations from '@/components/apps/applications/category/Operations'
import AppsCategoryAccountingFinance from '@/components/apps/applications/category/AccountingFinance'
import AppsCategoryMarketingAnalysis from '@/components/apps/applications/category/MarketingAnalysis'
import AppsCategoryOther from '@/components/apps/applications/category/Other'

// settings
import SettingsCompany from '@/components/apps/settings/company/All'
import SettingsAppearance from '@/components/apps/settings/appearance/All'
import SettingsUserList from '@/components/apps/settings/user/List'
import SettingsUserCreate from '@/components/apps/settings/user/Create'
import SettingsUserEdit from '@/components/apps/settings/user/Edit'
import SettingsRolePermissionList from '@/components/apps/settings/rolepermission/List'
import SettingsRolePermissionCreate from '@/components/apps/settings/rolepermission/Create'
import SettingsRolePermissionEdit from '@/components/apps/settings/rolepermission/Edit'
import SettingAdvanceAccount from '@/components/apps/settings/advance/All'

// billing
import BillingServiceUsed from '@/components/apps/billing/serviceused/Index'
import BillingInvoiceList from '@/components/apps/billing/invoice/List'
import BillingInvoiceSingle from '@/components/apps/billing/invoice/Single'
import BillingHistory from '@/components/apps/billing/history/Index'
import BillingPaymentMethod from '@/components/apps/billing/method/Index'
import BillingPreference from '@/components/apps/billing/preference/Index'

// billing package
import BillingPackageServiceUsed from '@/components/apps/billingpackage/package/Index'
import BillingPackageHistory from '@/components/apps/billingpackage/history/Index'
import BillingPackagePaymentMethod from '@/components/apps/billingpackage/method/Index'

// error
import ErrorPage from '@/components/error/Error'
import NotFoundPage from '@/components/error/404'

// admin
import AdminUserAll from '@/components/admin/UserAll'
import AdminUserLog from '@/components/admin/UserLog'
import AdminShopInfo from '@/components/admin/ShopInfo'

// admin log error api
import AdminLogErrorApiAll from '@/components/admin/log/error/api/All'

// admin log error front
import AdminLogErrorFrontAll from '@/components/admin/log/error/front/All'

// admin analytics business type
import AdminAnalyticsBusnessType from '@/components/admin/analytics/BusinessType'
import ShopDailySale from '@/components/admin/analytics/ShopDailySale'
import ShopDailySaleDetail from '@/components/admin/analytics/ShopDailySaleDetail'
import ShopAvgProductPrice from '@/components/admin/analytics/ShopAvgProductPrice'
import TrendApplication from '@/components/admin/analytics/TrendApplication'
import TrendApplicationModule from '@/components/admin/analytics/TrendApplicationModule'

// custom components
import VueProgressBar from 'vue-progressbar'
import InputTags from '@/components/custom/InputTags'
import Selectize from '@/components/custom/Selectize'
import SectionHeader from '@/components/custom/SectionHeader'
import SectionTitle from '@/components/custom/SectionTitle'
import Modifier from '@/components/custom/Modifier'
import Attribute from '@/components/custom/Attribute'
import Order from '@/components/custom/Order.vue'
import OrderGI from '@/components/custom/OrderGI.vue'
import OrderGR from '@/components/custom/OrderGR.vue'
import OrderGT from '@/components/custom/OrderGT.vue'
import Link from '@/components/custom/Link.vue'
import FormPaymentEntry from '@/components/custom/FormPaymentEntry.vue'
import FormGoodsReceipt from '@/components/custom/FormGoodsReceipt.vue'
import FormGoodsIssue from '@/components/custom/FormGoodsIssue.vue'
import FormInvoice from '@/components/custom/FormInvoice.vue'
import ItemList from '@/components/custom/ItemList.vue'
import BootstrapVue from 'bootstrap-vue'

var lang = LocalStorage.get('lang') ? LocalStorage.get('lang') : store.state.app.lang

/**
 ** Vue use
 **/
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Vuesax)
Vue.use(Router)
Vue.use(UUID)
Vue.use(VueBarcodeScanner)
Vue.component('v-date-picker', DatePicker)
Vue.use(VueProgressBar, {
  color: '#A3CA76',
  failedColor: '#f00',
  thickness: '3px',
})
Vue.use(VueGoogleCharts)
Vue.use(Vuelidate)
Vue.use(Cleave)
Vue.use(VueCardFormat)
Vue.use(VueTour)
Vue.component('v-chart', ECharts)
Vue.component('Cleave', Cleave)
Vue.component('BaseBody', BaseBody)
Vue.component('BaseTopBar', BaseTopBar)
Vue.component('BaseTopBarContent', BaseTopBarContent)
Vue.component('BaseContent', BaseContent)
Vue.component('BaseTable', BaseTable)
Vue.component('base-table-collapse', BaseTableCollapse)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseInputDatePicker', BaseInputDatePicker)
Vue.component('BaseDateRange', BaseDateRange)
Vue.component('BaseInputNumber', BaseInputNumber)
Vue.component('BaseInputTag', BaseInputTag)
Vue.component('BaseInputVariable', BaseInputVariable)
Vue.component('BaseInputSelector', BaseInputSelector)
Vue.component('BaseTextArea', BaseTextArea)
Vue.component('BaseRadioRich', BaseRadioRich)
Vue.component('BaseCheckbox', BaseCheckbox)
Vue.component('BaseSortLabel', BaseSortLabel)
Vue.component('BaseDropdown', BaseDropdown)
Vue.component('BaseSwitch', BaseSwitch)
Vue.component('base-dropdown-filter-date-range', BaseDropdownFilterDateRange)
Vue.component('base-dropdown-filter-download', BaseDropdownFilterDownload)
Vue.component('BaseAction', BaseAction)
Vue.component('BaseActionDropdown', BaseActionDropdown)
Vue.component('BaseActionUpdateStatus', BaseActionUpdateStatus)
Vue.component('base-filter-data-type', BaseFilterDataType)
Vue.component('BaseFilterDocProcessStatus', BaseFilterDocProcessStatus)
Vue.component('base-echart', BaseEChart)
Vue.component('base-filter-data-type', BaseFilterDataType)
Vue.component('BaseAssignItems', BaseAssignItems)
Vue.component('BaseAssignSkus', BaseAssignSkus)
Vue.component('baseConfirmDeleteModal', BaseConfirmDeleteModal)
Vue.component('BaseConfirmDiscardModal', BaseConfirmDiscardModal)
Vue.component('BaseAlertModal', BaseAlertModal)
Vue.component('BaseNotFoundData', BaseNotFoundData)
Vue.component('BaseFormAction', BaseFormAction)
Vue.component('BaseButton', BaseButton)
Vue.component('BaseButtonGroup', BaseButtonGroup)
Vue.component('BasePayrollCondition', BasePayrollCondition)
Vue.component('BasePaySlipEmployee', BasePaySlipEmployee)
Vue.component('BasePaySlipEmployeeHead', BasePaySlipEmployeeHead)
Vue.component('BasePaySlipEmployeeItem', BasePaySlipEmployeeItem)
Vue.component('BaseDocumentProcessStatus', BaseDocumentProcessStatus)
Vue.component('Section', Section)
Vue.component('FormRow', FormRow)
Vue.component('Col', Col)
Vue.component('Label', Label)
Vue.component('BaseSelectLotNumber', BaseSelectLotNumber)
Vue.component('BaseSelectLotNumberModal', BaseSelectLotNumberModal)
Vue.component('BaseSelectSerialNumber', BaseSelectSerialNumber)
Vue.component('BaseSelectSerialNumberModal', BaseSelectSerialNumberModal)
Vue.component('BaseGRPutAwayLot', BaseGRPutAwayLot)
Vue.component('BaseGRPutAwaySerial', BaseGRPutAwaySerial)
Vue.component('BaseGTPutAwayLot', BaseGTPutAwayLot)
Vue.component('BaseGTPutAwaySerial', BaseGTPutAwaySerial)
Vue.component('BaseBinLocationModal', BaseBinLocationModal)
Vue.component('BaseTableSkuLevel', BaseTableSkuLevel)
Vue.component('BaseVsInputNumber', BaseVsInputNumber)
Vue.component('BaseRolePermission', BaseRolePermission)
Vue.component('BaseSelectRolePermission', BaseSelectRolePermission)
Vue.component('BaseTableUsegeApp', BaseTableUsegeApp)
Vue.component('BaseTableUsegeBranch', BaseTableUsegeBranch)
Vue.component('BaseTableUsegeWarehouse', BaseTableUsegeWarehouse)
Vue.component('BaseTableUsegeUser', BaseTableUsegeUser)
Vue.component('BaseTableUsegeFile', BaseTableUsegeFile)
Vue.component('BaseTableUsegeMessageLine', BaseTableUsegeMessageLine)
Vue.component('BaseTableUsegeEmail', BaseTableUsegeEmail)
Vue.component('BaseTableUsegeQRCode', BaseTableUsegeQRCode)
Vue.component('BaseTableUsegeAppModule', BaseTableUsegeAppModule)
Vue.component('BaseLoading', BaseLoading)
Vue.component('BaseRadioPaymentMethod', BaseRadioPaymentMethod)
Vue.component('BasePayment', BasePayment)
Vue.component('BasePaymentForm', BasePaymentForm)
Vue.component('BaseCreditCardForm', BaseCreditCardForm)
Vue.component('BaseModal', BaseModal)
Vue.component('BaseModalOverLimit', BaseModalOverLimit)
Vue.component('BaseAppModuleListModule', BaseAppModuleListModule)
Vue.component('BaseFormPaymentMethod', BaseFormPaymentMethod)
Vue.component('BaseFormBillingPreference', BaseFormBillingPreference)
Vue.component('BaseModalCustomMasterData', BaseModalCustomMasterData)
Vue.component('BaseModalAckFreeTrialEnded', BaseModalAckFreeTrialEnded)
Vue.component('BaseModalPackage', BaseModalPackage)
Vue.component('report-sale-table', ReportSaleTable)
Vue.component('report-sale-chart', ReportSaleChart)
Vue.component('report-cashier-table', ReportCashierTable)
Vue.component('report-cashier-chart', ReportCashierChart)
Vue.component('report-inventory-table', ReportInventoryTable)
Vue.component('report-inventory-chart', ReportInventoryChart)
Vue.component('report-pos-diningoption-chart', ReportPosDiningOptionChart)
Vue.component('report-pos-paymentmethod-chart', ReportPosPaymentMethodChart)
Vue.component('report-pos-sku-chart', ReportPosSkuChart)
Vue.component('report-pos-category-chart', ReportPosCategoryChart)
Vue.component('HrmEmployeeForm', HrmEmployeeForm)
Vue.component('HrmDepartmentForm', HrmDepartmentForm)
Vue.component('HrmPositionForm', HrmPositionForm)
Vue.component('PayrollPaySlipForm', PayrollPaySlipForm)
Vue.component('PayrollEmployeeGroupForm', PayrollEmployeeGroupForm)
Vue.component('PayrollConditionForm', PayrollConditionForm)
Vue.component('WmsWarehouseForm', WmsWarehouseForm)
Vue.component('ImsLotNumberForm', ImsLotNumberForm)
Vue.component('ImsSerialNumberForm', ImsSerialNumberForm)
Vue.component('RolePermissionForm', RolePermissionForm)
Vue.component('UserPermissionForm', UserPermissionForm)
Vue.component('BillingInvoiceSummary', BillingInvoiceSummary)
Vue.component('BillingInvoiceUsage', BillingInvoiceUsage)
Vue.component('BillingPaymentMethodForm', BillingPaymentMethodForm)
Vue.component('ServiceUsedSummary', ServiceUsedSummary)
Vue.component('CustomMasterDataForm', CustomMasterDataForm)
Vue.component('SectionHeader', SectionHeader)
Vue.component('input-tags', InputTags)
Vue.component('selectize', Selectize)
Vue.component('SectionTitle', SectionTitle)
Vue.component('modifier', Modifier)
Vue.component('attribute', Attribute)
Vue.component('order', Order)
Vue.component('OrderGI', OrderGI)
Vue.component('OrderGR', OrderGR)
Vue.component('OrderGT', OrderGT)
Vue.component('RouterLinkCustom', Link)
Vue.component('form-paymententry', FormPaymentEntry)
Vue.component('form-goodsreceipt', FormGoodsReceipt)
Vue.component('form-goodsissue', FormGoodsIssue)
Vue.component('form-invoice', FormInvoice)
Vue.component('item-list', ItemList)
Vue.component('vue-bootstrap-autocomplete', VueBootstrapAutocomplete)
Vue.component('RecycleScroller', RecycleScroller)

/**
 ** check auth
 **/
var access_token = null,
  user_info = null,
  shop_info = null

if (LocalStorage.get('auth')) {
  access_token = LocalStorage.get('auth').access_token
  user_info = LocalStorage.get('auth').user_info
  shop_info = LocalStorage.get('auth').shop_info
}

if (user_info) {
  if (shop_info) {
    store.dispatch('LoggedInShop', {
      shop_id: shop_info.shop_id,
      user_id: user_info.user_id,
    })
  } else {
    store.dispatch('LoggedIn')
  }
}

/**
 ** check language
 **/
store.dispatch('switchLang', lang)

/**
 ** router
 **/

const router = new Router({
  routes: [
    {
      path: '/',
      beforeEnter: function (to, from, next) {
        next({
          path: '/signin',
        })
      },
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: function (to, from, next) {
        if (store.state.auth.auth.shop_info) {
          return next({
            path: '/desktop',
          })
        }
        if (store.state.auth.auth.user_info) {
          return next({
            path: '/company',
          })
        }
        next()
      },
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      beforeEnter: function (to, from, next) {
        if (store.state.auth.auth.shop_info) {
          return next({
            path: '/desktop',
          })
        }
        if (store.state.auth.auth.user_info) {
          return next({
            path: '/company',
          })
        }
        next()
      },
    },
    {
      path: '/company',
      name: 'ChooseShop',
      component: ChooseShop,
      meta: {
        requireLogin: true,
      },
      beforeEnter: function (to, from, next) {
        if (store.state.auth.auth.shop_info) {
          return next({
            path: '/desktop',
          })
        }
        next()
      },
    },
    {
      path: '/company/new',
      name: 'CreateShop',
      component: CreateShop,
      meta: {
        requireLogin: true,
      },
      beforeEnter: function (to, from, next) {
        if (store.state.auth.auth.shop_info) {
          return next({
            path: '/desktop',
          })
        }
        next()
      },
    },
    {
      path: '/verify/email',
      name: 'CheckVerifyEmail',
      component: CheckVerifyEmail,
    },
    {
      path: '/reset/password',
      name: 'ResetPassword',
      component: ResetPassword,
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: function (to, from, next) {
        store.dispatch('Logout')
      },
    },
    {
      path: '/callback/login-with-line',
      name: 'LoginWithLine',
      component: LoginWithLine,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
      },
    },
    {
      path: '/desktop/payment/invoice',
      name: 'PaymentInvoice',
      component: PaymentInvoice,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/payment/order/done',
      name: 'PaymentCallbackAuth',
      component: PaymentCallbackAuth,
      meta: {
        requireLogin: false,
        requireLoginShop: false,
        requireOwner: false,
      },
    },
    {
      path: '/desktop/payment/package',
      name: 'PaymentPackageInvoice',
      component: PaymentPackageInvoice,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/payment/package/done',
      name: 'PaymentPackageCallbackAuth',
      component: PaymentPackageCallbackAuth,
      meta: {
        requireLogin: false,
        requireLoginShop: false,
        requireOwner: false,
      },
    },
    {
      path: '/desktop',
      name: 'Home',
      component: Home,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
      },
    },
    {
      path: '/desktop/pos/dashboard',
      name: 'PosDashboard',
      component: PosDashboard,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          create: true,
        },
        info: {
          appId: 1,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/menu-online/qrcodes',
      name: 'PosMenuOnlineQRCode',
      component: PosMenuOnlineQRCode,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          view: true,
        },
        info: {
          appId: 1,
          moduleId: 5,
          subModuleId: 1,
        },
      },
    },
    // {
    //   path: '/desktop/pos/menu-online/acccess-history',
    //   name: 'PosMenuOnlineAccessHistory',
    //   component: PosMenuOnlineAccessHistory,
    //   meta: {
    //     requireLogin: true,
    //     requireLoginShop: true,
    //     requirePermissions: [1],
    //     requireAction: {
    //       view: true,
    //     },
    //     info: {
    //       appId: 1,
    //       moduleId: 5,
    //       subModuleId: 2,
    //     },
    //   },
    // },
    {
      path: '/desktop/pos/dashboard/session',
      name: 'PosDashboardSession',
      component: PosDashboardSession,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          create: true,
        },
        info: {
          appId: 1,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/summary',
      name: 'PosTransactionAll',
      component: PosTransactionAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          view: true,
        },
        info: {
          appId: 1,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/summary/session',
      name: 'PosTransactionDetail',
      component: PosTransactionDetail,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          view: true,
        },
        info: {
          appId: 1,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/branch',
      name: 'PosBranchAll',
      component: PosBranchAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          view: true,
        },
        info: {
          appId: 1,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/branch/new',
      name: 'PosBranchNew',
      component: PosBranchNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          create: true,
        },
        info: {
          appId: 1,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/branch/edit',
      name: 'PosBranchEdit',
      component: PosBranchEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          view: true,
        },
        info: {
          appId: 1,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/pos/config/settings',
      name: 'PosConfigurationSetting',
      component: PosConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          update: true,
        },
        info: {
          appId: 1,
          moduleId: 4,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/pos/config/notification',
      name: 'PosConfigurationNotification',
      component: PosConfigurationNotification,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [1],
        requireAction: {
          update: true,
        },
        info: {
          appId: 1,
          moduleId: 4,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/items/product/all',
      name: 'ProductAll',
      component: ProductAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/product/new',
      name: 'ProductNew',
      component: ProductNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          create: true,
        },
        info: {
          appId: 2,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/product/edit',
      name: 'ProductEdit',
      component: ProductEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/category/all',
      name: 'CategoryAll',
      component: CategoryAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/category/new',
      name: 'CategoryNew',
      component: CategoryNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          create: true,
        },
        info: {
          appId: 2,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/category/edit',
      name: 'CategoryEdit',
      component: CategoryEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/modifier/all',
      name: 'ModifierAll',
      component: ModifierAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/modifier/new',
      name: 'ModifierNew',
      component: ModifierNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          create: true,
        },
        info: {
          appId: 2,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/modifier/edit',
      name: 'ModifierEdit',
      component: ModifierEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/discount/all',
      name: 'DiscountAll',
      component: DiscountAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/discount/new',
      name: 'DiscountNew',
      component: DiscountNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          create: true,
        },
        info: {
          appId: 2,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/discount/edit',
      name: 'DiscountEdit',
      component: DiscountEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/recipe/all',
      name: 'RecipeAll',
      component: RecipeAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/recipe/new',
      name: 'RecipeNew',
      component: RecipeNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          create: true,
        },
        info: {
          appId: 2,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/items/recipe/edit',
      name: 'RecipeEdit',
      component: RecipeEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [2],
        requireAction: {
          view: true,
        },
        info: {
          appId: 2,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/overview/todo',
      name: 'InventoryTodo',
      component: InventoryTodo,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 1,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/inventory/overview/skus-level',
      name: 'InventorySkuLevel',
      component: InventorySkuLevel,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 1,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/inventory/stockcontrols',
      name: 'StockControl',
      component: StockControl,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/activities',
      name: 'StockActivity',
      component: StockActivity,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-receipt/all',
      name: 'GoodsReceiptAll',
      component: GoodsReceiptAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-receipt/new',
      name: 'GoodsReceiptNew',
      component: GoodsReceiptNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          create: true,
        },
        info: {
          appId: 3,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-receipt/doc',
      name: 'GoodsReceiptEdit',
      component: GoodsReceiptEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-issue/all',
      name: 'GoodsIssueAll',
      component: GoodsIssueAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 5,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-issue/new',
      name: 'GoodsIssueNew',
      component: GoodsIssueNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          create: true,
        },
        info: {
          appId: 3,
          moduleId: 5,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-issue/doc',
      name: 'GoodsIssueEdit',
      component: GoodsIssueEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 5,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-transfer/all',
      name: 'GoodsTransferAll',
      component: GoodsTransferAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-transfer/new',
      name: 'GoodsTransferNew',
      component: GoodsTransferNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          create: true,
        },
        info: {
          appId: 3,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/goods-transfer/doc',
      name: 'GoodsTransferEdit',
      component: GoodsTransferEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/lot-number/all',
      name: 'InventoryLotList',
      component: InventoryLotList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 7,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/lot-number/create',
      name: 'InventoryLotCreate',
      component: InventoryLotCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          create: true,
        },
        info: {
          appId: 3,
          moduleId: 7,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/lot-number/edit',
      name: 'InventoryLotEdit',
      component: InventoryLotEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 7,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/serial-number/all',
      name: 'InventorySerialList',
      component: InventorySerialList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 8,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/serial-number/create',
      name: 'InventorySerialCreate',
      component: InventorySerialCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          create: true,
        },
        info: {
          appId: 3,
          moduleId: 8,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/serial-number/edit',
      name: 'InventorySerialEdit',
      component: InventorySerialEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 8,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/warehouse/all',
      name: 'WarehouseList',
      component: WarehouseList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 9,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/warehouse/new',
      name: 'WarehouseCreate',
      component: WarehouseCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          create: true,
        },
        info: {
          appId: 3,
          moduleId: 9,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/warehouse/edit',
      name: 'WarehouseEdit',
      component: WarehouseEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          view: true,
        },
        info: {
          appId: 3,
          moduleId: 9,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/inventory/config/settings',
      name: 'InventoryConfigurationSetting',
      component: InventoryConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          update: true,
        },
        info: {
          appId: 3,
          moduleId: 10,
          subModuleId: 4,
        },
      },
    },
    {
      path: '/desktop/inventory/config/assign-sku',
      name: 'InventoryConfigurationAssignSku',
      component: InventoryConfigurationAssignSku,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          update: true,
        },
        info: {
          appId: 3,
          moduleId: 10,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/inventory/config/assign-lot-serial',
      name: 'InventoryConfigurationAssignLotSerial',
      component: InventoryConfigurationAssignLotSerial,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          update: true,
        },
        info: {
          appId: 3,
          moduleId: 10,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/inventory/config/notification',
      name: 'InventoryConfigurationNotification',
      component: InventoryConfigurationNotification,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [3],
        requireAction: {
          update: true,
        },
        info: {
          appId: 3,
          moduleId: 10,
          subModuleId: 3,
        },
      },
    },
    {
      path: '/desktop/purchases/requisition/all',
      name: 'PurchaseRequisitionAll',
      component: PurchaseRequisitionAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          view: true,
        },
        info: {
          appId: 4,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/requisition/new',
      name: 'PurchaseRequisitionNew',
      component: PurchaseRequisitionNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          create: true,
        },
        info: {
          appId: 4,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/requisition/doc',
      name: 'PurchaseRequisitionEdit',
      component: PurchaseRequisitionEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          view: true,
        },
        info: {
          appId: 4,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/order/all',
      name: 'PurchaseOrderAll',
      component: PurchaseOrderAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          view: true,
        },
        info: {
          appId: 4,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/order/new',
      name: 'PurchaseOrderNew',
      component: PurchaseOrderNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          create: true,
        },
        info: {
          appId: 4,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/order/doc',
      name: 'PurchaseOrderEdit',
      component: PurchaseOrderEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          view: true,
        },
        info: {
          appId: 4,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/types',
      name: 'PurchaseType',
      component: PurchaseType,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          view: true,
        },
        info: {
          appId: 4,
          moduleId: 4,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/purchases/config/settings',
      name: 'PurchaseConfigurationSetting',
      component: PurchaseConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          update: true,
        },
        info: {
          appId: 4,
          moduleId: 2,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/purchases/config/notification',
      name: 'PurchaseConfigurationNotification',
      component: PurchaseConfigurationNotification,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [4],
        requireAction: {
          update: true,
        },
        info: {
          appId: 4,
          moduleId: 2,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/sales/order/all',
      name: 'SaleOrderAll',
      component: SaleOrderAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [5],
        requireAction: {
          view: true,
        },
        info: {
          appId: 5,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/sales/order/new',
      name: 'SaleOrderNew',
      component: SaleOrderNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [5],
        requireAction: {
          create: true,
        },
        info: {
          appId: 5,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/sales/order/doc',
      name: 'SaleOrderEdit',
      component: SaleOrderEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [5],
        requireAction: {
          view: true,
        },
        info: {
          appId: 5,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/sales/types',
      name: 'SaleType',
      component: SaleType,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [5],
        requireAction: {
          view: true,
        },
        info: {
          appId: 5,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/sales/config/settings',
      name: 'SaleConfigurationSetting',
      component: SaleConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [5],
        requireAction: {
          update: true,
        },
        info: {
          appId: 5,
          moduleId: 2,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/expenses/claim/all',
      name: 'ExpensesClaimAll',
      component: ExpensesClaimAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [6],
        requireAction: {
          view: true,
        },
        info: {
          appId: 6,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/expenses/claim/new',
      name: 'ExpensesClaimNew',
      component: ExpensesClaimNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [6],
        requireAction: {
          create: true,
        },
        info: {
          appId: 6,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/expenses/claim/doc',
      name: 'ExpensesClaimEdit',
      component: ExpensesClaimEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [6],
        requireAction: {
          view: true,
        },
        info: {
          appId: 6,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/expenses/types',
      name: 'ExpensesType',
      component: ExpensesType,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [6],
        requireAction: {
          view: true,
        },
        info: {
          appId: 6,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/expenses/config/settings',
      name: 'ExpensesConfigurationSetting',
      component: ExpensesConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [6],
        requireAction: {
          update: true,
        },
        info: {
          appId: 6,
          moduleId: 2,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/report/income-statement',
      name: 'ReportIncomeStatementAll',
      component: ReportIncomeStatementAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/report/pos/sale',
      name: 'ReportPosSale',
      component: ReportPosSale,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 2,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/report/pos/cashier',
      name: 'ReportPosCashier',
      component: ReportPosCashier,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 2,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/report/pos/skus',
      name: 'ReportPosProduct',
      component: ReportPosProduct,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 2,
          subModuleId: 3,
        },
      },
    },
    {
      path: '/desktop/report/pos/category',
      name: 'ReportPosCategory',
      component: ReportPosCategory,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 2,
          subModuleId: 4,
        },
      },
    },
    {
      path: '/desktop/report/pos/dining-option',
      name: 'ReportPosDiningOption',
      component: ReportPosDiningOption,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 2,
          subModuleId: 5,
        },
      },
    },
    {
      path: '/desktop/report/pos/payment-method',
      name: 'ReportPosPaymentMethod',
      component: ReportPosPaymentMethod,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 2,
          subModuleId: 6,
        },
      },
    },
    {
      path: '/desktop/report/expense/description',
      name: 'ReportExpenseDescription',
      component: ReportExpenseDescription,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 4,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/report/expense/category',
      name: 'ReportExpenseCategory',
      component: ReportExpenseCategory,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 4,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/report/expense/employee',
      name: 'ReportExpenseEmployee',
      component: ReportExpenseEmployee,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 4,
          subModuleId: 3,
        },
      },
    },
    {
      path: '/desktop/report/expense/approver',
      name: 'ReportExpenseApprover',
      component: ReportExpenseApprover,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 4,
          subModuleId: 4,
        },
      },
    },
    {
      path: '/desktop/report/expense/vendor',
      name: 'ReportExpenseVendor',
      component: ReportExpenseVendor,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 4,
          subModuleId: 5,
        },
      },
    },
    {
      path: '/desktop/report/purchase/sku',
      name: 'ReportPurchaseSku',
      component: ReportPurchaseSku,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 5,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/report/purchase/category',
      name: 'ReportPurchaseCategory',
      component: ReportPurchaseCategory,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 5,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/report/purchase/employee',
      name: 'ReportPurchaseEmployee',
      component: ReportPurchaseEmployee,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 5,
          subModuleId: 3,
        },
      },
    },
    {
      path: '/desktop/report/purchase/approver',
      name: 'ReportPurchaseApprover',
      component: ReportPurchaseApprover,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 5,
          subModuleId: 4,
        },
      },
    },
    {
      path: '/desktop/report/purchase/vendor',
      name: 'ReportPurchaseVendor',
      component: ReportPurchaseVendor,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 5,
          subModuleId: 5,
        },
      },
    },
    {
      path: '/desktop/report/inventory/balance',
      name: 'ReportInventoryBalance',
      component: ReportInventoryBalance,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 3,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/report/inventory/value',
      name: 'ReportInventoryValue',
      component: ReportInventoryValue,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 3,
          subModuleId: 2,
        },
      },
    },
    {
      path: '/desktop/report/inventory/in-out',
      name: 'ReportInventoryInOut',
      component: ReportInventoryInOut,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 3,
          subModuleId: 3,
        },
      },
    },
    {
      path: '/desktop/report/inventory/behavior',
      name: 'ReportInventoryBehavior',
      component: ReportInventoryBehavior,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [8],
        requireAction: {
          view: true,
        },
        info: {
          appId: 8,
          moduleId: 3,
          subModuleId: 4,
        },
      },
    },
    {
      path: '/desktop/contact/all',
      name: 'ContactListAll',
      component: ContactListAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          view: true,
        },
        info: {
          appId: 11,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/contact/customer/all',
      name: 'ContactCustomerAll',
      component: ContactCustomerAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          view: true,
        },
        info: {
          appId: 11,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/contact/customer/new',
      name: 'ContactCustomerNew',
      component: ContactCustomerNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          create: true,
        },
        info: {
          appId: 11,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/contact/customer/edit',
      name: 'ContactCustomerEdit',
      component: ContactCustomerEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          view: true,
        },
        info: {
          appId: 11,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/contact/vendor/all',
      name: 'ContactVendorAll',
      component: ContactVendorAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          view: true,
        },
        info: {
          appId: 11,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/contact/vendor/new',
      name: 'ContactVendorNew',
      component: ContactVendorNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          create: true,
        },
        info: {
          appId: 11,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/contact/vendor/edit',
      name: 'ContactVendorEdit',
      component: ContactVendorEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [11],
        requireAction: {
          view: true,
        },
        info: {
          appId: 11,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/overview',
      name: 'AccountsOverviewAll',
      component: AccountsOverviewAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/invoice/all',
      name: 'AccountsInvoiceAll',
      component: AccountsInvoiceAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/invoice/new',
      name: 'AccountsInvoiceNew',
      component: AccountsInvoiceNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          create: true,
        },
        info: {
          appId: 12,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/invoice/doc',
      name: 'AccountsInvoiceEdit',
      component: AccountsInvoiceEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/receipt/all',
      name: 'AccountsReceiptAll',
      component: AccountsReceiptAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 5,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/receipt/doc',
      name: 'AccountsReceiptEdit',
      component: AccountsReceiptEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 5,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/payment-entry/all',
      name: 'AccountsPaymentEntryAll',
      component: AccountsPaymentEntryAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/payment-entry/new',
      name: 'AccountsPaymentEntryNew',
      component: AccountsPaymentEntryNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          create: true,
        },
        info: {
          appId: 12,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/payment-entry/doc',
      name: 'AccountsPaymentEntryEdit',
      component: AccountsPaymentEntryEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/journal-entry/all',
      name: 'AccountsJournalEntryAll',
      component: AccountsJournalEntryAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/journal-entry/new',
      name: 'AccountsJournalEntryNew',
      component: AccountsJournalEntryNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          create: true,
        },
        info: {
          appId: 12,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/journal-entry/doc',
      name: 'AccountsJournalEntryEdit',
      component: AccountsJournalEntryEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 6,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/chart-of-accounts',
      name: 'AccountsChartOfAccount',
      component: AccountsChartOfAccount,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 7,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/tax/all',
      name: 'TaxAll',
      component: TaxAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 8,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/tax/new',
      name: 'TaxNew',
      component: TaxNew,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          create: true,
        },
        info: {
          appId: 12,
          moduleId: 8,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/tax/edit',
      name: 'TaxEdit',
      component: TaxEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          view: true,
        },
        info: {
          appId: 12,
          moduleId: 8,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/accounting/config/settings',
      name: 'AccountConfigurationSetting',
      component: AccountConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [12],
        requireAction: {
          update: true,
        },
        info: {
          appId: 12,
          moduleId: 4,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/hrm/employee/all',
      name: 'EmployeeList',
      component: EmployeeList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          view: true,
        },
        info: {
          appId: 13,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/employee/new',
      name: 'EmployeeCreate',
      component: EmployeeCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          create: true,
        },
        info: {
          appId: 13,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/employee/edit',
      name: 'EmployeeEdit',
      component: EmployeeEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          view: true,
        },
        info: {
          appId: 13,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/department/all',
      name: 'DepartmentList',
      component: DepartmentList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          view: true,
        },
        info: {
          appId: 13,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/department/new',
      name: 'DepartmentCreate',
      component: DepartmentCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          create: true,
        },
        info: {
          appId: 13,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/department/edit',
      name: 'DepartmentEdit',
      component: DepartmentEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          view: true,
        },
        info: {
          appId: 13,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/position/all',
      name: 'PositionList',
      component: PositionList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          view: true,
        },
        info: {
          appId: 13,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/position/new',
      name: 'PositionCreate',
      component: PositionCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          create: true,
        },
        info: {
          appId: 13,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/hrm/position/edit',
      name: 'PositionEdit',
      component: PositionEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [13],
        requireAction: {
          view: true,
        },
        info: {
          appId: 13,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/payslip/all',
      name: 'PaySlipList',
      component: PaySlipList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          view: true,
        },
        info: {
          appId: 14,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/payslip/new',
      name: 'PaySlipCreate',
      component: PaySlipCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          create: true,
        },
        info: {
          appId: 14,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/payslip/edit',
      name: 'PaySlipEdit',
      component: PaySlipEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          view: true,
        },
        info: {
          appId: 14,
          moduleId: 1,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/employee-group/all',
      name: 'EmployeeGroupList',
      component: EmployeeGroupList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          view: true,
        },
        info: {
          appId: 14,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/employee-group/new',
      name: 'EmployeeGroupCreate',
      component: EmployeeGroupCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          create: true,
        },
        info: {
          appId: 14,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/employee-group/edit',
      name: 'EmployeeGroupEdit',
      component: EmployeeGroupEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          view: true,
        },
        info: {
          appId: 14,
          moduleId: 2,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/condition/all',
      name: 'PaySlipConditionList',
      component: PaySlipConditionList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          view: true,
        },
        info: {
          appId: 14,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/condition/new',
      name: 'PaySlipConditionCreate',
      component: PaySlipConditionCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          create: true,
        },
        info: {
          appId: 14,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/condition/edit',
      name: 'PaySlipConditionEdit',
      component: PaySlipConditionEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          view: true,
        },
        info: {
          appId: 14,
          moduleId: 3,
          subModuleId: null,
        },
      },
    },
    {
      path: '/desktop/payroll/config/settings',
      name: 'PayrollConfigurationSetting',
      component: PayrollConfigurationSetting,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requirePermissions: [14],
        requireAction: {
          update: true,
        },
        info: {
          appId: 14,
          moduleId: 4,
          subModuleId: 1,
        },
      },
    },
    {
      path: '/desktop/apps/category/all',
      name: 'AppsCategoryAll',
      component: AppsCategoryAll,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/apps/category/boost-sales',
      name: 'AppsCategoryBoostSales',
      component: AppsCategoryBoostSales,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/apps/category/operations',
      name: 'AppsCategoryOparations',
      component: AppsCategoryOparations,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/apps/category/accounts-finance',
      name: 'AppsCategoryAccountingFinance',
      component: AppsCategoryAccountingFinance,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/apps/category/marketing-analysis',
      name: 'AppsCategoryMarketingAnalysis',
      component: AppsCategoryMarketingAnalysis,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/apps/category/other',
      name: 'AppsCategoryOther',
      component: AppsCategoryOther,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/company',
      name: 'SettingsCompany',
      component: SettingsCompany,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/appearance',
      name: 'SettingsAppearance',
      component: SettingsAppearance,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/user/all',
      name: 'SettingsUserList',
      component: SettingsUserList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/user/new',
      name: 'SettingsUserCreate',
      component: SettingsUserCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/user/edit',
      name: 'SettingsUserEdit',
      component: SettingsUserEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/role-permissions/all',
      name: 'SettingsRolePermissionList',
      component: SettingsRolePermissionList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/role-permissions/new',
      name: 'SettingsRolePermissionCreate',
      component: SettingsRolePermissionCreate,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/role-permissions/edit',
      name: 'SettingsRolePermissionEdit',
      component: SettingsRolePermissionEdit,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/settings/advance/account',
      name: 'SettingAdvanceAccount',
      component: SettingAdvanceAccount,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/service-used',
      name: 'BillingServiceUsed',
      component: BillingServiceUsed,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/invoice/all',
      name: 'BillingInvoiceList',
      component: BillingInvoiceList,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/invoice/detail',
      name: 'BillingInvoiceSingle',
      component: BillingInvoiceSingle,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/history',
      name: 'BillingHistory',
      component: BillingHistory,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/payment-method',
      name: 'BillingPaymentMethod',
      component: BillingPaymentMethod,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/preferences',
      name: 'BillingPreference',
      component: BillingPreference,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/package/list',
      name: 'BillingPackageServiceUsed',
      component: BillingPackageServiceUsed,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/package/history',
      name: 'BillingPackageHistory',
      component: BillingPackageHistory,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/desktop/billing/package/payment-method',
      name: 'BillingPackagePaymentMethod',
      component: BillingPackagePaymentMethod,
      meta: {
        requireLogin: true,
        requireLoginShop: true,
        requireOwner: true,
      },
    },
    {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage,
    },
    {
      path: '/admin/users',
      name: 'AdminUserAll',
      component: AdminUserAll,
    },
    {
      path: '/admin/user/logs',
      name: 'AdminUserLog',
      component: AdminUserLog,
    },
    {
      path: '/admin/shop/info',
      name: 'AdminShopInfo',
      component: AdminShopInfo,
    },
    {
      path: '/admin/log/error/api',
      name: 'AdminLogErrorApiAll',
      component: AdminLogErrorApiAll,
    },
    {
      path: '/admin/log/error/front',
      name: 'AdminLogErrorFrontAll',
      component: AdminLogErrorFrontAll,
    },
    {
      path: '/admin/analytics/business-type',
      name: 'AdminAnalyticsBusnessType',
      component: AdminAnalyticsBusnessType,
    },
    {
      path: '/admin/analytics/shop-daily-sale',
      name: 'ShopDailySale',
      component: ShopDailySale,
    },
    {
      path: '/admin/analytics/shop-daily-sale/detail',
      name: 'ShopDailySaleDetail',
      component: ShopDailySaleDetail,
    },
    {
      path: '/admin/analytics/shop-avg-product-price',
      name: 'ShopAvgProductPrice',
      component: ShopAvgProductPrice,
    },
    {
      path: '/admin/analytics/trending-application',
      name: 'TrendApplication',
      component: TrendApplication,
    },
    {
      path: '/admin/analytics/trending-application-module',
      name: 'TrendApplicationModule',
      component: TrendApplicationModule,
    },
    {
      path: '*',
      name: '404',
      component: NotFoundPage,
    },
  ],
})

if (project.config.node_env === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-134937135-1',
    router,
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js